import { render } from "./AttestaDetails.vue?vue&type=template&id=52eae6bc"
import script from "./AttestaDetails.vue?vue&type=script&lang=js"
export * from "./AttestaDetails.vue?vue&type=script&lang=js"

import "./AttestaDetails.vue?vue&type=style&index=0&id=52eae6bc&lang=scss"

import exportComponent from "D:\\wwwroot\\yunchi\\yc-vue-source\\yunman\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__